import React from 'react'

import useAxios from 'hooks/useAxios'
import IntercomCreateEventIntegration from '.'
import { Loader } from 'shared/components/Loader'

export default function IntercomCreateEventIntegrationContainer({
  isAuthenticated,
  integrationSetting,
  updateCompanyIntegrationSettingAPILoading,
  updateCompanyIntegrationSetting,
}) {
  const { data: surveyIntegrationSettings } = useAxios({
    url: 'survey/survey-integration-setting/by-integration/?integration_type=intercom&name=push_contact_event',
  })

  function activateIntegration() {
    updateCompanyIntegrationSetting(integrationSetting, true)
  }
  function deactivateIntegration() {
    updateCompanyIntegrationSetting(integrationSetting, false)
  }

  if (!surveyIntegrationSettings) {
    return <Loader withContainer />
  }

  return (
    <IntercomCreateEventIntegration
      isAuthenticated={isAuthenticated}
      integrationSetting={integrationSetting}
      activateIntegration={activateIntegration}
      deactivateIntegration={deactivateIntegration}
      surveyIntegrationSettings={surveyIntegrationSettings}
      updateCompanyIntegrationSettingAPILoading={updateCompanyIntegrationSettingAPILoading}
    />
  )
}



// WEBPACK FOOTER //
// ./node_modules/eslint-loader??ref--0-0!./src/components/IntercomCreateEventIntegration/container.js